import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation } from 'swiper/modules';
export default class SubjectsList {
    constructor() {
        this.section = document.querySelector('.subjects-list');
        this.slider = this.section.querySelector('.swiper');
        this.navigationPrev = this.section.querySelector('.slider-button-prev');
        this.navigationNext = this.section.querySelector('.slider-button-next');
        this.navigationPrevMobile = this.section.querySelector('.slider-button-prev-mobile');
        this.navigationNextMobile = this.section.querySelector('.slider-button-next-mobile');
        this.pagination = this.section.querySelector('.swiper-pagination-nav');

        this.allSubjects = this.section.querySelectorAll('.swiper-slide');
        this.allSubjectsLinks = this.section.querySelectorAll('.swiper-slide a');

        this.swiper = null;

        this.ready();
        this.checkCategoryState();
    }

    ready() {
        this.swiper = new Swiper(this.slider, {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: '56px',
            grabCursor: true,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                0: {
                    navigation: {
                        nextEl: this.navigationNextMobile,
                        prevEl: this.navigationPrevMobile,
                    },
                },
                1024: {
                    // centeredSlides: true,
                },
            },
        });
    }

    checkCategoryState() {
        const fullUrl = window.location.href;
        const urlPart = fullUrl.split('/');
        const categoryIndex = urlPart.indexOf('categorias');

        if (categoryIndex !== -1 && categoryIndex < urlPart.length - 1) {
            const categorySlug = urlPart[categoryIndex + 1];

            document.querySelector('.subjects-list').scrollIntoView({
                behavior: 'smooth',
            });

            this.allSubjects.forEach((category) => {
                const slugSlide = category.dataset.categoria;
                if (categorySlug === slugSlide) {
                    this.clearAllSlidesActiveLinks();
                    category.querySelector('a').classList.add('active');
                    if (this.swiper !== null) {
                        this.swiper.slideTo(category.dataset.id + 1);
                    }
                }
            });
        } else {
            this.clearAllSlidesActiveLinks();
            document.querySelector('.slide-category-all a').classList.add('active');
        }
    }

    clearAllSlidesActiveLinks() {
        this.allSubjectsLinks.forEach((link) => {
            link.classList.remove('active');
        });
    }
}

if (document.querySelector('.subjects-list')) {
    new SubjectsList();
}
